import React from 'react';
import { Table } from 'react-bootstrap';
import { SortableContainer } from 'react-sortable-hoc';
import SocialMediaLinkItemSortable from './socialMediaLinkItemSortable';

const SocialMediaLinksSortable = SortableContainer((props) => {
  return (
    <Table className="sections-table-list">
      <tbody>
        {props.items && props.items.map((value, index) => (
          <SocialMediaLinkItemSortable
            value={value}
            index={index}
            key={`item-${index}-tablelist`}
          />
        ))}
      </tbody>
    </Table>
  );
});

export default SocialMediaLinksSortable;



// WEBPACK FOOTER //
// ./src/app/screens/general/footerContent/footerContentView/socialMediaLinksSortable.js